import _ from 'lodash';
import React from 'react';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import usePaths from 'src/hooks/use-paths';
import { CategoriesForMenu as categories } from 'shared/constants';
import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';
import { defaultFilters, replaceEdibleWithIngestible, checkNeedToMakeEdibleIngestible } from '../carousels.utils';

export function CategoryCarousel(props) {
  const { section, dispensaryState } = props;
  const { label, category } = section;
  const currentCategory = _.find(categories, [`value`, category]) || category;

  const makeEdibleIngestible = checkNeedToMakeEdibleIngestible(dispensaryState, category);

  const { products, loading } = useDispensaryProducts({
    filters: { ...defaultFilters, category },
    perPage: 25,
  });
  const { href } = usePaths({ category: currentCategory });
  const hasCategory = products?.length > 0;
  if (!hasCategory && !loading) {
    return null;
  }

  const transformedHref = makeEdibleIngestible ? replaceEdibleWithIngestible(href) : href;
  const legacyLabel = section.legacyLabel ?? label;
  const hasHeadingOverride = section.headingOverride && section.headingOverride === label;
  const transformedLabel = makeEdibleIngestible && !hasHeadingOverride ? replaceEdibleWithIngestible(label) : label;
  const analyticsSection = makeEdibleIngestible ? replaceEdibleWithIngestible(legacyLabel) : legacyLabel;

  return (
    <ProductCarousel
      products={products}
      isLoading={loading}
      href={transformedHref}
      hideTitle={props?.showTitle === false}
      hideLink={props?.showLink === false}
      title={transformedLabel}
      analyticsSection={analyticsSection}
    />
  );
}
